import { router, usePage } from "@inertiajs/react"
import { useEffect, useRef } from "react"

import { detectTimezoneSettingsAccountPath } from "@/routes"
import type { Account } from "@/types"

export function useTimezoneDetection() {
  const { account, auth } = usePage().props as {
    account?: Account
    auth?: { user?: unknown; type?: string }
  }
  const attempted = useRef(false)

  useEffect(() => {
    if (
      attempted.current ||
      !auth?.user ||
      auth.type !== "user" ||
      !account ||
      account.timezone_detected
    )
      return

    attempted.current = true

    let timezone = "UTC"
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
    } catch {
      // Fall back to UTC if detection fails
    }

    router.patch(
      detectTimezoneSettingsAccountPath(),
      { timezone },
      { preserveState: true, preserveScroll: true },
    )
  }, [account, auth])
}
